
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13048',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13048",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9875",
  "foundations-components": "static-1.8339",
  "foundations-components-legacy": "static-1.1364",
  "foundations-theming": "static-1.4668",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.85",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8241",
  "hub-http-shared-msw-handlers": "static-1.10479",
  "hubspot-dlb": "static-2.1877",
  "hubspot-url-utils": "static-1.4282",
  "HubStyleTokens": "static-2.11697",
  "I18n": "static-7.1652",
  "jasmine-runner": "static-1.6666",
  "marketplace-discovery-studio-lib": "static-1.501",
  "marketplace-storefront-base": "static-1.13111",
  "quartz": "static-1.7324",
  "react-dlb": "static-1.84",
  "react-rhumb": "static-1.16924",
  "reactive-variable-buffer-atom": "static-1.3071",
  "reporting-testing-lib": "static-1.10407",
  "reselect": "static-3.8",
  "settings-ui-lib": "static-1.12737",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7518",
  "ui-addon-i18n": "static-1.11363",
  "ui-addon-react-router-dom": "static-1.9750",
  "unified-auth": "static-1.755",
  "unified-auth-core-lib": "static-1.1037",
  "usage-tracker": "static-1.7572",
  "usage-tracker-core": "static-1.7422",
  "customer-data-property-utils": "static-1.8313",
  "hub-http": "static-1.6431",
  "integrations-lib": "static-1.16862",
  "marketplace-ui-common": "static-1.20496",
  "marketplace-ui-install": "static-1.482",
  "property-management-iframe": "static-1.13899",
  "quartz-config": "static-1.1102",
  "quartz-core": "static-1.6543",
  "quartz-routing": "static-1.754",
  "quick-fetch": "static-1.4068",
  "react": "static-7.190",
  "rpc-client-utils": "static-1.4879",
  "ts-schema": "static-1.4228",
  "ui-universal-auth": "static-1.9241",
  "UIComponents": "static-3.8643",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9849",
  "react-redux": "static-7.75",
  "redux": "static-4.16",
  "styled-components": "static-2.94",
  "bend-plugin-trellis-migration": "static-1.3550",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3601",
  "quartz-webpack": "static-1.3548",
  "bend-plugin-quartz-routing": "static-1.402",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4608",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5091",
  "foundations-theming-specialty": "static-1.2384",
  "framer-motion": "static-1.75",
  "hs-story-utils": "static-1.9642",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.52",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5491",
  "react-virtualized": "static-2.103",
  "StyleGuideUI": "static-3.492",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2387",
  "ui-fonts": "static-1.959",
  "ui-images": "static-2.1219",
  "bend-plugin-foundations-theming": "static-1.3151",
  "foundations-theming-base": "static-1.3653",
  "stylex": "static-1.37",
  "HeadJS": "static-2.782",
  "hs-test-utils-bend-plugin": "static-1.3352",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4536",
  "ui-addon-video-player": "static-1.8922",
  "ai-components-ui-library": "static-1.9525",
  "ai-rendering-library": "static-1.10945",
  "chirp-fetch": "static-1.2105",
  "connections-embed-lib": "static-1.1387",
  "copilot-toolkit": "static-1.11692",
  "feedback-loader": "static-1.29693",
  "laboratory-lib": "static-3.7368",
  "marketplace-embed": "static-1.22755",
  "marketplace-ui-details": "static-1.10391",
  "marketplace-ui-reviews": "static-1.20451",
  "marketplace-ui-tracking": "static-1.14666",
  "sanitize-text": "static-1.8366",
  "usage-tracker-multi": "static-1.5986",
  "usage-tracker-session-replay": "static-1.5258",
  "wootric-nps": "static-1.7136",
  "quartz-head": "static-1.989",
  "web-vitals": "static-1.9",
  "apollo-link-hub-http": "static-2.4874",
  "immer": "static-1.94",
  "immerable": "static-1.4367",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2635",
  "reporting-data": "static-1.68474",
  "cssUtils": "static-1.857",
  "flux-actions": "static-1.356",
  "HubStyle": "static-2.12004",
  "PatternValidationJS": "static-1.3114",
  "react-colorpicker": "static-2.10428",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10582",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7562",
  "icons": "static-2.671",
  "marketplace-ui-apps-core": "static-1.19028",
  "storybook-react": "static-1.36",
  "trellis-story-utils": "static-1.4726",
  "foundations-components-test-utils": "static-1.5822",
  "quartz-i18n": "static-1.999",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.298",
  "ads-unified-auth-lib": "static-1.867",
  "google-sheets-integration-lib": "static-1.877",
  "microsoft-drive-integration-lib": "static-1.1006",
  "surveymonkey-integration-lib": "static-1.320",
  "slack-ui-library": "static-1.10615",
  "fsm": "static-1.3953",
  "customer-data-objects": "static-1.7901",
  "property-translator": "static-1.5612",
  "hs-locale-management": "static-1.230",
  "frontend-preferences-client": "static-1.8145",
  "hs-promise-utils": "static-1.5811",
  "hubspot-apollo-client": "static-1.5094",
  "integrations-error-boundary-lib": "static-1.14277",
  "integrations-tracking-lib": "static-1.5825",
  "native-integrations-shared-strings": "static-1.7994",
  "sanitize": "static-1.4693",
  "superstore": "static-1.4973",
  "ui-shepherd-react": "static-3.10478",
  "ai-settings-ui-library": "static-1.8217",
  "hub-http-janus": "static-1.860",
  "hubspotter-http": "static-1.4800",
  "immutable-less": "static-1.4867",
  "marketplace-ui-client-types": "static-1.17903",
  "nav-meta": "static-1.30306",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18285",
  "ui-product-approvals-common": "static-1.836",
  "ai-studio-lib": "static-1.12282",
  "hubspot-prosemirror": "static-1.18852",
  "integrations-reconnect-lib": "static-1.360",
  "ui-addon-iframeable": "static-1.9293",
  "ui-addon-integrations-directory-panel": "static-2.8241",
  "ui-product-approvals": "static-1.28941",
  "ui-tool-access": "static-1.10370",
  "inbound-db-properties-service-client": "static-1.3996",
  "property-management-common": "static-1.6187",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.557",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.999",
  "quartz-test": "static-1.999",
  "quartz-tracking": "static-1.703",
  "trellis-components": "static-1.2406",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.289",
  "bender-build-tools": "static-1.3344",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22478",
  "ContentUtils": "static-1.68999",
  "customer-data-objects-ui-components": "static-1.13247",
  "sassPrefix": "static-1.161",
  "avatar-components": "static-1.2714",
  "breeze-engine-core": "static-1.785",
  "breeze-onboarding-components": "static-1.563",
  "customer-data-filters-ui": "static-1.40655",
  "customer-data-reference-ui-components": "static-1.13395",
  "embedded-academy-lib": "static-1.15253",
  "ExportDialog": "static-6.10597",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41857",
  "reporting-snowflake": "static-1.57092",
  "reporting-ui-components": "static-2.65745",
  "reporting-visualizations": "static-1.60550",
  "trellis-theming": "static-1.1170",
  "ui-addon-teams": "static-1.21823",
  "upgrade-components-lib": "static-1.422",
  "magpie-lib": "static-1.5702",
  "navigation-components": "static-1.18669",
  "breeze-engine-lib": "static-1.1507",
  "magpie-types": "static-1.5162",
  "simple-logging-lib": "static-1.3265",
  "fail-safe": "static-1.166",
  "app-governance-lib": "static-1.2234",
  "developer-experience-shared-components": "static-1.10715",
  "purchase-motions-components": "static-1.6249",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.9911",
  "usage-tracker-anonymous": "static-1.5989",
  "usage-tracker-public": "static-1.7383",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3918",
  "reference-resolvers": "static-1.8399",
  "ui-extensibility-client-types": "static-1.4137",
  "hubspot-apollo-cache": "static-1.553",
  "universal-page-editor-lib": "static-1.3228",
  "final-form": "static-1.73",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3390",
  "atom": "static-1.5292",
  "merchandise-lib": "static-1.272",
  "salesImages": "static-1.530",
  "codemirror": "static-5.98",
  "react-codemirror": "static-1.10856",
  "ui-addon-draggable": "static-3.4971",
  "content-assistance-lib": "static-1.8095",
  "content-media-capture": "static-1.5220",
  "customer-data-ui-utilities": "static-1.10043",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24295",
  "growth-payments-core": "static-1.26018",
  "knowledge-content-types": "static-1.8609",
  "payment-link-components": "static-1.24027",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20195",
  "ui-addon-emoji-picker": "static-1.10103",
  "ui-business-units-lib": "static-1.9298",
  "video-components-external": "static-1.11988",
  "video-data-lib": "static-1.35646",
  "navigation-messaging": "static-1.7996",
  "collaboration-sidebar": "static-1.58549",
  "react-dnd-compat": "static-1.4833",
  "batch-promise": "static-1.1761",
  "crm-component-utils": "static-1.39680",
  "crm-properties-common-lib": "static-1.6105",
  "customer-data-properties": "static-1.52353",
  "external-options-client-types": "static-1.4277",
  "framework-data-schema-resolvers": "static-1.7110",
  "property-value-citations": "static-1.2967",
  "reference-resolvers-lite": "static-1.8315",
  "hubspotter-http-shared-msw-handlers": "static-1.10477",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.35",
  "cms-field-types": "static-1.5031",
  "content-icons-ui": "static-1.2292",
  "breeze-artifacts-sdk": "static-1.96",
  "onboarding-journeys-lib": "static-1.720",
  "pulse": "static-1.838",
  "conversations-skeleton-state": "static-1.7466",
  "crm-message-bus": "static-1.43576",
  "customer-data-filters-ui-msw-helpers": "static-1.23090",
  "events-data-lib": "static-1.458",
  "FormUrlGenerator": "static-2.4941",
  "framework-builder-read-service-client": "static-1.4157",
  "framework-data-schema-quick-fetch": "static-1.7015",
  "multi-account-reference-resolvers": "static-1.1201",
  "onboarding-tours": "static-1.16999",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14317",
  "academy-common-lib": "static-1.14713",
  "dashboard-lib": "static-1.82456",
  "getting-started-shared-tasks": "static-1.19056",
  "hubspot-prosemirror-plugins": "static-1.18844",
  "share-with-third-party-component-lib": "static-1.8921",
  "ui-asset-management-lib": "static-1.11307",
  "user-context": "static-1.5330",
  "reporting-plugins": "static-1.10667",
  "reporting-reports": "static-1.68152",
  "idb-keyval": "static-1.47",
  "reactive-lib": "static-1.937",
  "nest": "static-1.454",
  "breeze-engine-chat-components": "static-1.485",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.117",
  "framework-listing-lib": "static-2.29317",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31235",
  "apps-service-types": "static-1.3983",
  "oauth-service-types": "static-1.4471",
  "onboarding-scopes": "static-1.6675",
  "purchase-motions-api": "static-1.6252",
  "signup-constants": "static-1.19441",
  "signup-ui-url-generator": "static-2.8274",
  "onboarding-tours-client": "static-1.5213",
  "one-click-checkout": "static-1.297",
  "platform-infra-nav-components": "static-1.7820",
  "subscription-experience-data-types": "static-1.15162",
  "crm-record-cards-service-types": "static-1.3734",
  "location-customization-utils-lib": "static-1.9935",
  "redux-thunk": "static-2.43",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.74",
  "ui-coaching-tips": "static-1.29162",
  "content-media-composition-data-lib": "static-1.13024",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4642",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.529",
  "ui-addon-opt": "static-4.8579",
  "commerce-tours-lib": "static-1.6495",
  "growth-onboarding-reliability": "static-1.5297",
  "sales-checkout-service-client": "static-1.3753",
  "data-token-picker": "static-1.16778",
  "FileManagerLib": "static-1.39935",
  "content-media-compositions": "static-2.17031",
  "media-bridge-lib": "static-1.19297",
  "chatspot-widget-iframe": "static-1.22469",
  "collaboration-sidebar-common": "static-1.3346",
  "marketing-platform-lib": "static-1.7086",
  "card-properties-lib": "static-1.44848",
  "commerce-subscription-lib": "static-1.37623",
  "crm-actions": "static-1.6567",
  "crm-cards-sdk": "static-1.44310",
  "customer-data-properties-shared-msw-handlers": "static-1.9806",
  "customer-data-tracking": "static-1.7100",
  "hs-resources": "static-1.403",
  "calling-global-api": "static-1.65272",
  "calling-internal-common": "static-1.31532",
  "calling-lifecycle-internal": "static-1.66654",
  "calling-lifecycle-messages": "static-1.58948",
  "commerce-products-lib": "static-1.10345",
  "conditional-properties-service-client": "static-1.3947",
  "crm-links": "static-1.6536",
  "crm-index-visualization-core": "static-1.4429",
  "crm-pipelines-api-client-types": "static-1.4285",
  "formula-editor": "static-1.14635",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4365",
  "meetings-icalendar-utils-lib": "static-1.851",
  "multi-currency-client-types": "static-1.3841",
  "object-builder-ui-client": "static-1.49458",
  "pipeline-validation-client-types": "static-1.4117",
  "smart-property-lib": "static-1.8124",
  "tiered-pricing": "static-1.1814",
  "topics-actions-lib": "static-1.375",
  "ui-addon-form-validation": "static-1.11203",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.229",
  "bend-plugin-pulse": "static-1.341",
  "event-emitter": "static-1.1169",
  "fast-json-patch": "static-1.66",
  "restore-request-side-panel-lib": "static-1.1471",
  "growth-data-modal": "static-1.5778",
  "growth-onboarding-confetti": "static-1.3277",
  "growth-onboarding-next-action-utils": "static-1.2542",
  "onboarding-tours-utils": "static-1.1065",
  "ui-shepherd-tracker": "static-1.7859",
  "academy-service-client": "static-1.3906",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39794",
  "SafeStorage": "static-1.4620",
  "video-embed": "static-1.36480",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24868",
  "viral-links-lib": "static-1.7290",
  "nested-table": "static-1.452",
  "timezone-utils": "static-2.5464",
  "getting-started-shared-tasks-store": "static-1.18174",
  "campaign-roi-lib": "static-1.9928",
  "ui-addon-calendars": "static-2.5542",
  "customer-data-views-management": "static-1.25889",
  "framework-data-table": "static-2.12398",
  "nudge-client-utils": "static-1.3028",
  "nudge-custom-ui-functions": "static-1.1381",
  "switchboard-lib": "static-1.438",
  "access-check-ui-lib": "static-1.1424",
  "app-users-service-client": "static-1.5834",
  "app-users-service-types": "static-1.5242",
  "mini-checkout-client": "static-1.27392",
  "onboarding-utils": "static-1.5579",
  "permissions-shared-i18n-strings-fe": "static-1.2104",
  "ui-coaching-tips-shared-config": "static-1.29147",
  "checkout-sdk": "static-3.24235",
  "payment-method-components": "static-1.7064",
  "touchless-buying-components": "static-1.6103",
  "upgrade-catalog-service-types": "static-1.3706",
  "edison-service-client-types": "static-1.605",
  "growth-onboarding-feedback-components": "static-1.6799",
  "audio-components": "static-1.6236",
  "FileManagerImages": "static-1.37446",
  "video-components": "static-1.13990",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92681",
  "customer-data-sidebar": "static-2.46594",
  "enrichment-properties-lib": "static-1.17665",
  "ui-addon-draggable-compat": "static-2.4478",
  "universal-record-utils-lib": "static-1.1640",
  "commerce-billing-lib": "static-1.19871",
  "commerce-shared-components-lib": "static-1.19080",
  "commerce-tools-ui-lib": "static-1.10911",
  "crm-fe-perf": "static-1.23116",
  "calling-error-reporting": "static-1.31539",
  "shared-worker-versioning": "static-1.11256",
  "calling-usage-tracker": "static-1.6756",
  "voice-sms-access-library": "static-1.1797",
  "commerce-permissions": "static-1.994",
  "products-iframe-lib": "static-1.8447",
  "products-ui-components-shared-msw-handlers": "static-1.10861",
  "crm-index-associations-lib": "static-1.6658",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10562",
  "sales-views-client-types": "static-1.4474",
  "bark-lib": "static-1.16723",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.533",
  "policy-lib": "static-1.7010",
  "react-tinymce": "static-1.55821",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10625",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54947",
  "tinymce-plugins": "static-1.58061",
  "tinymce-themes": "static-1.56917",
  "onboarding-data-sync-lib": "static-1.2349",
  "growth-onboarding-next-action-components": "static-1.2570",
  "user-context-client": "static-1.4754",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4749",
  "outpost": "static-1.4380",
  "draft-convert": "static-2.76",
  "draft-extend": "static-3.79",
  "draft-js": "static-5.81",
  "draft-plugins": "static-2.22044",
  "sales-email-signature-service-client": "static-1.4062",
  "ts-utils-lib": "static-1.391",
  "crm-export-dialog": "static-1.6502",
  "crm-view-components": "static-1.936",
  "react-beautiful-dnd": "static-1.66",
  "customer-data-associations": "static-1.7549",
  "nudge-custom-function-registry": "static-1.2785",
  "nudge-renderer-utils": "static-1.3104",
  "whisper-core-api": "static-1.7169",
  "InboxConnectUtils": "static-4.15404",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46694",
  "hub-http-rxjs": "static-1.825",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4208",
  "company-details-components": "static-1.6418",
  "react-performance-metrics-lib": "static-1.771",
  "pricing-pages-ui-components": "static-1.15301",
  "quote-checkout-service-types": "static-1.3672",
  "social-insights-client-types": "static-1.22637",
  "crm_universal": "static-1.22384",
  "customer-data-email": "static-1.18413",
  "card-payment-highlight-lib": "static-1.37818",
  "card-subscription-highlight-lib": "static-1.40046",
  "commerce-contract-lib": "static-1.13089",
  "invoices-highlight-card-lib": "static-1.55448",
  "orders-highlight-card-lib": "static-1.22038",
  "products-highlight-card-lib": "static-1.18628",
  "quotes-highlight-card-lib": "static-1.72687",
  "crm-source-interpretation-lib": "static-1.5551",
  "crm-object-search-query-utilities": "static-1.10055",
  "utility-belt": "static-1.2748",
  "payments-enrollment-embed-lib": "static-1.23652",
  "stripe-embedded-components": "static-1.7884",
  "customer-data-rte": "static-1.33515",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6153",
  "payments-post-enroll-local-storage-lib": "static-1.5323",
  "qrcode-generator": "static-1.72",
  "quotes-client-types": "static-1.38777",
  "calling-orchestration-schema": "static-1.36574",
  "react-reducer-toolkit": "static-1.16216",
  "hub-http-contrib": "static-1.3256",
  "interframe": "static-3.4972",
  "tinymce-data": "static-1.41032",
  "ui-addon-sales-email": "static-1.5429",
  "layout-dnd-components": "static-1.12851",
  "layout-dnd-utils": "static-1.11826",
  "ui-brand-identity-lib": "static-1.16105",
  "NamespacedHubStyle": "static-2.9199",
  "meetings-connect-utils-lib": "static-1.7824",
  "access-control-lib": "static-1.10655",
  "EmailComponents": "static-1.55399",
  "EmailData": "static-1.54077",
  "redux-less": "static-2.9697",
  "company-details-service-types": "static-1.4156",
  "segments-query-core": "static-1.1639",
  "pricing-pages-api": "static-1.15166",
  "sequences-lib": "static-1.8409",
  "ui-gdpr-components": "static-1.10571",
  "products-ui-components": "static-1.40863",
  "accounting-integrations-ui-components": "static-1.7426",
  "invoices-ui-lib": "static-1.55464",
  "commerce-products-api": "static-1.2604",
  "invoices-iframe-lib": "static-1.57522",
  "quotes-modal-lib": "static-1.103365",
  "quotes-ui-lib": "static-1.81408",
  "stripe-connect-js": "static-1.73",
  "draft-content-plugins": "static-1.28778",
  "ContentData": "static-1.69074",
  "layout-data-lib": "static-1.10151",
  "ContentComponents": "static-2.71955",
  "marketing-contacts-lib": "static-1.10807",
  "marketing-email-service-types": "static-1.2055",
  "messaging-editing-lib": "static-1.46975",
  "messaging-usage-based-billing-components-lib": "static-1.1837",
  "automation-ui-source-apps": "static-1.19508",
  "automation-ui-types": "static-1.20426",
  "messaging-types-lib": "static-1.46712",
  "onboarding-settings-client": "static-1.4726",
  "sequences-client-types-lib": "static-1.8266",
  "commerce-tax-lib": "static-1.758",
  "price-books-api": "static-1.1563",
  "price-books-components": "static-1.1621",
  "property-description-translator": "static-1.4056",
  "ramp-editor": "static-1.748",
  "commerce-analytics-service-client": "static-1.3741",
  "totals-ui-components": "static-1.24158",
  "SalesContentIndexUI": "static-3.9532",
  "advanced-menus-core": "static-1.15477",
  "advanced-menus-lib": "static-1.12362",
  "ui-memberships-settings-lib": "static-1.34659",
  "automation-ui-ubb": "static-1.6342",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7551",
  "data-token-views": "static-1.16759",
  "forms-utils-lib": "static-1.12977",
  "payments-embed-points-lib": "static-1.13466",
  "simple-menus-core": "static-1.15476",
  "simple-menus-lib": "static-1.16993",
  "videoconference-integration-components": "static-1.7139",
  "marketing-contacts-client": "static-1.7723",
  "mc-hard-limits-client-types": "static-1.118",
  "automation-applications-service-types": "static-1.3632",
  "automation-platform-service-types": "static-1.2643",
  "ContentEditorUI": "static-2.77735",
  "short-messages-app-service-client": "static-1.4138",
  "web-interactives-components": "static-1.14134",
  "web-interactives-data": "static-1.14135",
  "messaging-shared-utils-lib": "static-1.1286",
  "messaging-user-info-utils-lib": "static-1.1456",
  "email-portal-health-service-types": "static-1.1195",
  "line-items-api": "static-1.1003",
  "commerce-totals-service-types": "static-1.3967",
  "FireAlarmUi": "static-1.4659",
  "sales-templates-service-types-lib": "static-1.4318",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22362",
  "automation-ui-usage-tracking": "static-1.21825",
  "data-studio-ubb": "static-1.3361",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27522",
  "content-management-data-lib": "static-1.5827",
  "copilot-plugins": "static-1.11664",
  "cta-picker": "static-1.36946",
  "customer-agent-discovery-components-lib": "static-1.3727",
  "editor-components": "static-1.13540",
  "editor-iframe-lib": "static-1.8698",
  "error-messaging-js": "static-1.5412",
  "FormsCommonComponents": "static-1.86428",
  "pictos": "static-7.189",
  "react-transition-group": "static-2.68",
  "redux-request-state": "static-1.10866",
  "SharedLegalStrings": "static-1.1963",
  "smart-content-core": "static-1.43028",
  "smart-content-lib": "static-1.43681",
  "social-composer-lib": "static-1.59991",
  "structured-content-lib": "static-1.25772",
  "theme-previewer-lib": "static-1.53798",
  "tinymce-copilot": "static-1.17015",
  "xray-recommendation-lib": "static-1.8175",
  "automation-ui-routing": "static-1.21783",
  "sql-reporting-client-types": "static-1.5824",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42659",
  "campaigns-utils-lib": "static-1.3414",
  "reporting-enablement": "static-1.23654",
  "forms-ai-lib": "static-1.4650",
  "codemirror-dlb": "static-1.59294",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6655",
  "report-customization-components": "static-1.13745",
  "data-quality-ui-library": "static-1.13617",
  "reporting-filters": "static-1.862",
  "reporting-insights-lib": "static-1.2402"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13048",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9875",
  "foundations-components": "/foundations-components/static-1.8339",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1364",
  "foundations-theming": "/foundations-theming/static-1.4668",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.85",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8241",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10479",
  "hubspot-dlb": "/hubspot-dlb/static-2.1877",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
  "HubStyleTokens": "/HubStyleTokens/static-2.11697",
  "I18n": "/I18n/static-7.1652",
  "jasmine-runner": "/jasmine-runner/static-1.6666",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.501",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13111",
  "quartz": "/quartz/static-1.7324",
  "react-dlb": "/react-dlb/static-1.84",
  "react-rhumb": "/react-rhumb/static-1.16924",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3071",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10407",
  "reselect": "/reselect/static-3.8",
  "settings-ui-lib": "/settings-ui-lib/static-1.12737",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7518",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11363",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9750",
  "unified-auth": "/unified-auth/static-1.755",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1037",
  "usage-tracker": "/usage-tracker/static-1.7572",
  "usage-tracker-core": "/usage-tracker-core/static-1.7422",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8313",
  "hub-http": "/hub-http/static-1.6431",
  "integrations-lib": "/integrations-lib/static-1.16862",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20496",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.482",
  "property-management-iframe": "/property-management-iframe/static-1.13899",
  "quartz-config": "/quartz-config/static-1.1102",
  "quartz-core": "/quartz-core/static-1.6543",
  "quartz-routing": "/quartz-routing/static-1.754",
  "quick-fetch": "/quick-fetch/static-1.4068",
  "react": "/react/static-7.190",
  "rpc-client-utils": "/rpc-client-utils/static-1.4879",
  "ts-schema": "/ts-schema/static-1.4228",
  "ui-universal-auth": "/ui-universal-auth/static-1.9241",
  "UIComponents": "/UIComponents/static-3.8643",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9849",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.94",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3550",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3601",
  "quartz-webpack": "/quartz-webpack/static-1.3548",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.402",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4608",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5091",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2384",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-story-utils": "/hs-story-utils/static-1.9642",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.52",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5491",
  "react-virtualized": "/react-virtualized/static-2.103",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2387",
  "ui-fonts": "/ui-fonts/static-1.959",
  "ui-images": "/ui-images/static-2.1219",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3151",
  "foundations-theming-base": "/foundations-theming-base/static-1.3653",
  "stylex": "/stylex/static-1.37",
  "HeadJS": "/HeadJS/static-2.782",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3352",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4536",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8922",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9525",
  "ai-rendering-library": "/ai-rendering-library/static-1.10945",
  "chirp-fetch": "/chirp-fetch/static-1.2105",
  "connections-embed-lib": "/connections-embed-lib/static-1.1387",
  "copilot-toolkit": "/copilot-toolkit/static-1.11692",
  "feedback-loader": "/feedback-loader/static-1.29693",
  "laboratory-lib": "/laboratory-lib/static-3.7368",
  "marketplace-embed": "/marketplace-embed/static-1.22755",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10391",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20451",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14666",
  "sanitize-text": "/sanitize-text/static-1.8366",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5986",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5258",
  "wootric-nps": "/wootric-nps/static-1.7136",
  "quartz-head": "/quartz-head/static-1.989",
  "web-vitals": "/web-vitals/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4874",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4367",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2635",
  "reporting-data": "/reporting-data/static-1.68474",
  "cssUtils": "/cssUtils/static-1.857",
  "flux-actions": "/flux-actions/static-1.356",
  "HubStyle": "/HubStyle/static-2.12004",
  "PatternValidationJS": "/PatternValidationJS/static-1.3114",
  "react-colorpicker": "/react-colorpicker/static-2.10428",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10582",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7562",
  "icons": "/icons/static-2.671",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19028",
  "storybook-react": "/storybook-react/static-1.36",
  "trellis-story-utils": "/trellis-story-utils/static-1.4726",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5822",
  "quartz-i18n": "/quartz-i18n/static-1.999",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.298",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.867",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.877",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1006",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.320",
  "slack-ui-library": "/slack-ui-library/static-1.10615",
  "fsm": "/fsm/static-1.3953",
  "customer-data-objects": "/customer-data-objects/static-1.7901",
  "property-translator": "/property-translator/static-1.5612",
  "hs-locale-management": "/hs-locale-management/static-1.230",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8145",
  "hs-promise-utils": "/hs-promise-utils/static-1.5811",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5094",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14277",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5825",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7994",
  "sanitize": "/sanitize/static-1.4693",
  "superstore": "/superstore/static-1.4973",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10478",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8217",
  "hub-http-janus": "/hub-http-janus/static-1.860",
  "hubspotter-http": "/hubspotter-http/static-1.4800",
  "immutable-less": "/immutable-less/static-1.4867",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17903",
  "nav-meta": "/nav-meta/static-1.30306",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18285",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.836",
  "ai-studio-lib": "/ai-studio-lib/static-1.12282",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18852",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.360",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9293",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8241",
  "ui-product-approvals": "/ui-product-approvals/static-1.28941",
  "ui-tool-access": "/ui-tool-access/static-1.10370",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3996",
  "property-management-common": "/property-management-common/static-1.6187",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.557",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.999",
  "quartz-test": "/quartz-test/static-1.999",
  "quartz-tracking": "/quartz-tracking/static-1.703",
  "trellis-components": "/trellis-components/static-1.2406",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.289",
  "bender-build-tools": "/bender-build-tools/static-1.3344",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22478",
  "ContentUtils": "/ContentUtils/static-1.68999",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13247",
  "sassPrefix": "/sassPrefix/static-1.161",
  "avatar-components": "/avatar-components/static-1.2714",
  "breeze-engine-core": "/breeze-engine-core/static-1.785",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.563",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40655",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13395",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15253",
  "ExportDialog": "/ExportDialog/static-6.10597",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41857",
  "reporting-snowflake": "/reporting-snowflake/static-1.57092",
  "reporting-ui-components": "/reporting-ui-components/static-2.65745",
  "reporting-visualizations": "/reporting-visualizations/static-1.60550",
  "trellis-theming": "/trellis-theming/static-1.1170",
  "ui-addon-teams": "/ui-addon-teams/static-1.21823",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.422",
  "magpie-lib": "/magpie-lib/static-1.5702",
  "navigation-components": "/navigation-components/static-1.18669",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1507",
  "magpie-types": "/magpie-types/static-1.5162",
  "simple-logging-lib": "/simple-logging-lib/static-1.3265",
  "fail-safe": "/fail-safe/static-1.166",
  "app-governance-lib": "/app-governance-lib/static-1.2234",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10715",
  "purchase-motions-components": "/purchase-motions-components/static-1.6249",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9911",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5989",
  "usage-tracker-public": "/usage-tracker-public/static-1.7383",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3918",
  "reference-resolvers": "/reference-resolvers/static-1.8399",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4137",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.553",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3228",
  "final-form": "/final-form/static-1.73",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3390",
  "atom": "/atom/static-1.5292",
  "merchandise-lib": "/merchandise-lib/static-1.272",
  "salesImages": "/salesImages/static-1.530",
  "codemirror": "/codemirror/static-5.98",
  "react-codemirror": "/react-codemirror/static-1.10856",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4971",
  "content-assistance-lib": "/content-assistance-lib/static-1.8095",
  "content-media-capture": "/content-media-capture/static-1.5220",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10043",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24295",
  "growth-payments-core": "/growth-payments-core/static-1.26018",
  "knowledge-content-types": "/knowledge-content-types/static-1.8609",
  "payment-link-components": "/payment-link-components/static-1.24027",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20195",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10103",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9298",
  "video-components-external": "/video-components-external/static-1.11988",
  "video-data-lib": "/video-data-lib/static-1.35646",
  "navigation-messaging": "/navigation-messaging/static-1.7996",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58549",
  "react-dnd-compat": "/react-dnd-compat/static-1.4833",
  "batch-promise": "/batch-promise/static-1.1761",
  "crm-component-utils": "/crm-component-utils/static-1.39680",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6105",
  "customer-data-properties": "/customer-data-properties/static-1.52353",
  "external-options-client-types": "/external-options-client-types/static-1.4277",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7110",
  "property-value-citations": "/property-value-citations/static-1.2967",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8315",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10477",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "cms-field-types": "/cms-field-types/static-1.5031",
  "content-icons-ui": "/content-icons-ui/static-1.2292",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.96",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.720",
  "pulse": "/pulse/static-1.838",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7466",
  "crm-message-bus": "/crm-message-bus/static-1.43576",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23090",
  "events-data-lib": "/events-data-lib/static-1.458",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4941",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4157",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7015",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1201",
  "onboarding-tours": "/onboarding-tours/static-1.16999",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14317",
  "academy-common-lib": "/academy-common-lib/static-1.14713",
  "dashboard-lib": "/dashboard-lib/static-1.82456",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19056",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18844",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8921",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11307",
  "user-context": "/user-context/static-1.5330",
  "reporting-plugins": "/reporting-plugins/static-1.10667",
  "reporting-reports": "/reporting-reports/static-1.68152",
  "idb-keyval": "/idb-keyval/static-1.47",
  "reactive-lib": "/reactive-lib/static-1.937",
  "nest": "/nest/static-1.454",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.485",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.117",
  "framework-listing-lib": "/framework-listing-lib/static-2.29317",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31235",
  "apps-service-types": "/apps-service-types/static-1.3983",
  "oauth-service-types": "/oauth-service-types/static-1.4471",
  "onboarding-scopes": "/onboarding-scopes/static-1.6675",
  "purchase-motions-api": "/purchase-motions-api/static-1.6252",
  "signup-constants": "/signup-constants/static-1.19441",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8274",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5213",
  "one-click-checkout": "/one-click-checkout/static-1.297",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7820",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15162",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3734",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9935",
  "redux-thunk": "/redux-thunk/static-2.43",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29162",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13024",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4642",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.529",
  "ui-addon-opt": "/ui-addon-opt/static-4.8579",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6495",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5297",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3753",
  "data-token-picker": "/data-token-picker/static-1.16778",
  "FileManagerLib": "/FileManagerLib/static-1.39935",
  "content-media-compositions": "/content-media-compositions/static-2.17031",
  "media-bridge-lib": "/media-bridge-lib/static-1.19297",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22469",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3346",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7086",
  "card-properties-lib": "/card-properties-lib/static-1.44848",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37623",
  "crm-actions": "/crm-actions/static-1.6567",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44310",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9806",
  "customer-data-tracking": "/customer-data-tracking/static-1.7100",
  "hs-resources": "/hs-resources/static-1.403",
  "calling-global-api": "/calling-global-api/static-1.65272",
  "calling-internal-common": "/calling-internal-common/static-1.31532",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66654",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58948",
  "commerce-products-lib": "/commerce-products-lib/static-1.10345",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3947",
  "crm-links": "/crm-links/static-1.6536",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4429",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4285",
  "formula-editor": "/formula-editor/static-1.14635",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4365",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.851",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3841",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49458",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4117",
  "smart-property-lib": "/smart-property-lib/static-1.8124",
  "tiered-pricing": "/tiered-pricing/static-1.1814",
  "topics-actions-lib": "/topics-actions-lib/static-1.375",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11203",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.229",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.341",
  "event-emitter": "/event-emitter/static-1.1169",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1471",
  "growth-data-modal": "/growth-data-modal/static-1.5778",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3277",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2542",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1065",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7859",
  "academy-service-client": "/academy-service-client/static-1.3906",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39794",
  "SafeStorage": "/SafeStorage/static-1.4620",
  "video-embed": "/video-embed/static-1.36480",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24868",
  "viral-links-lib": "/viral-links-lib/static-1.7290",
  "nested-table": "/nested-table/static-1.452",
  "timezone-utils": "/timezone-utils/static-2.5464",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18174",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9928",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5542",
  "customer-data-views-management": "/customer-data-views-management/static-1.25889",
  "framework-data-table": "/framework-data-table/static-2.12398",
  "nudge-client-utils": "/nudge-client-utils/static-1.3028",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1381",
  "switchboard-lib": "/switchboard-lib/static-1.438",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1424",
  "app-users-service-client": "/app-users-service-client/static-1.5834",
  "app-users-service-types": "/app-users-service-types/static-1.5242",
  "mini-checkout-client": "/mini-checkout-client/static-1.27392",
  "onboarding-utils": "/onboarding-utils/static-1.5579",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2104",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29147",
  "checkout-sdk": "/checkout-sdk/static-3.24235",
  "payment-method-components": "/payment-method-components/static-1.7064",
  "touchless-buying-components": "/touchless-buying-components/static-1.6103",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3706",
  "edison-service-client-types": "/edison-service-client-types/static-1.605",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6799",
  "audio-components": "/audio-components/static-1.6236",
  "FileManagerImages": "/FileManagerImages/static-1.37446",
  "video-components": "/video-components/static-1.13990",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92681",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46594",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17665",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4478",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1640",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19871",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19080",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10911",
  "crm-fe-perf": "/crm-fe-perf/static-1.23116",
  "calling-error-reporting": "/calling-error-reporting/static-1.31539",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11256",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6756",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1797",
  "commerce-permissions": "/commerce-permissions/static-1.994",
  "products-iframe-lib": "/products-iframe-lib/static-1.8447",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10861",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6658",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10562",
  "sales-views-client-types": "/sales-views-client-types/static-1.4474",
  "bark-lib": "/bark-lib/static-1.16723",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.533",
  "policy-lib": "/policy-lib/static-1.7010",
  "react-tinymce": "/react-tinymce/static-1.55821",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10625",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54947",
  "tinymce-plugins": "/tinymce-plugins/static-1.58061",
  "tinymce-themes": "/tinymce-themes/static-1.56917",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2349",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2570",
  "user-context-client": "/user-context-client/static-1.4754",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4749",
  "outpost": "/outpost/static-1.4380",
  "draft-convert": "/draft-convert/static-2.76",
  "draft-extend": "/draft-extend/static-3.79",
  "draft-js": "/draft-js/static-5.81",
  "draft-plugins": "/draft-plugins/static-2.22044",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4062",
  "ts-utils-lib": "/ts-utils-lib/static-1.391",
  "crm-export-dialog": "/crm-export-dialog/static-1.6502",
  "crm-view-components": "/crm-view-components/static-1.936",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.66",
  "customer-data-associations": "/customer-data-associations/static-1.7549",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2785",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3104",
  "whisper-core-api": "/whisper-core-api/static-1.7169",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15404",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46694",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.825",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4208",
  "company-details-components": "/company-details-components/static-1.6418",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.771",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15301",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3672",
  "social-insights-client-types": "/social-insights-client-types/static-1.22637",
  "crm_universal": "/crm_universal/static-1.22384",
  "customer-data-email": "/customer-data-email/static-1.18413",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37818",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40046",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13089",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55448",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22038",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18628",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72687",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5551",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10055",
  "utility-belt": "/utility-belt/static-1.2748",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23652",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7884",
  "customer-data-rte": "/customer-data-rte/static-1.33515",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6153",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5323",
  "qrcode-generator": "/qrcode-generator/static-1.72",
  "quotes-client-types": "/quotes-client-types/static-1.38777",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36574",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16216",
  "hub-http-contrib": "/hub-http-contrib/static-1.3256",
  "interframe": "/interframe/static-3.4972",
  "tinymce-data": "/tinymce-data/static-1.41032",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5429",
  "layout-dnd-components": "/layout-dnd-components/static-1.12851",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11826",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16105",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9199",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7824",
  "access-control-lib": "/access-control-lib/static-1.10655",
  "EmailComponents": "/EmailComponents/static-1.55399",
  "EmailData": "/EmailData/static-1.54077",
  "redux-less": "/redux-less/static-2.9697",
  "company-details-service-types": "/company-details-service-types/static-1.4156",
  "segments-query-core": "/segments-query-core/static-1.1639",
  "pricing-pages-api": "/pricing-pages-api/static-1.15166",
  "sequences-lib": "/sequences-lib/static-1.8409",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10571",
  "products-ui-components": "/products-ui-components/static-1.40863",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7426",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55464",
  "commerce-products-api": "/commerce-products-api/static-1.2604",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57522",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103365",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81408",
  "stripe-connect-js": "/stripe-connect-js/static-1.73",
  "draft-content-plugins": "/draft-content-plugins/static-1.28778",
  "ContentData": "/ContentData/static-1.69074",
  "layout-data-lib": "/layout-data-lib/static-1.10151",
  "ContentComponents": "/ContentComponents/static-2.71955",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10807",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2055",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46975",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1837",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19508",
  "automation-ui-types": "/automation-ui-types/static-1.20426",
  "messaging-types-lib": "/messaging-types-lib/static-1.46712",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4726",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8266",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.758",
  "price-books-api": "/price-books-api/static-1.1563",
  "price-books-components": "/price-books-components/static-1.1621",
  "property-description-translator": "/property-description-translator/static-1.4056",
  "ramp-editor": "/ramp-editor/static-1.748",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3741",
  "totals-ui-components": "/totals-ui-components/static-1.24158",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9532",
  "advanced-menus-core": "/advanced-menus-core/static-1.15477",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12362",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34659",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6342",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7551",
  "data-token-views": "/data-token-views/static-1.16759",
  "forms-utils-lib": "/forms-utils-lib/static-1.12977",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13466",
  "simple-menus-core": "/simple-menus-core/static-1.15476",
  "simple-menus-lib": "/simple-menus-lib/static-1.16993",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7139",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7723",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.118",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3632",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2643",
  "ContentEditorUI": "/ContentEditorUI/static-2.77735",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4138",
  "web-interactives-components": "/web-interactives-components/static-1.14134",
  "web-interactives-data": "/web-interactives-data/static-1.14135",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1286",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1456",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1195",
  "line-items-api": "/line-items-api/static-1.1003",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3967",
  "FireAlarmUi": "/FireAlarmUi/static-1.4659",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4318",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22362",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21825",
  "data-studio-ubb": "/data-studio-ubb/static-1.3361",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27522",
  "content-management-data-lib": "/content-management-data-lib/static-1.5827",
  "copilot-plugins": "/copilot-plugins/static-1.11664",
  "cta-picker": "/cta-picker/static-1.36946",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3727",
  "editor-components": "/editor-components/static-1.13540",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8698",
  "error-messaging-js": "/error-messaging-js/static-1.5412",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86428",
  "pictos": "/pictos/static-7.189",
  "react-transition-group": "/react-transition-group/static-2.68",
  "redux-request-state": "/redux-request-state/static-1.10866",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1963",
  "smart-content-core": "/smart-content-core/static-1.43028",
  "smart-content-lib": "/smart-content-lib/static-1.43681",
  "social-composer-lib": "/social-composer-lib/static-1.59991",
  "structured-content-lib": "/structured-content-lib/static-1.25772",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53798",
  "tinymce-copilot": "/tinymce-copilot/static-1.17015",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8175",
  "automation-ui-routing": "/automation-ui-routing/static-1.21783",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5824",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42659",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3414",
  "reporting-enablement": "/reporting-enablement/static-1.23654",
  "forms-ai-lib": "/forms-ai-lib/static-1.4650",
  "codemirror-dlb": "/codemirror-dlb/static-1.59294",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6655",
  "report-customization-components": "/report-customization-components/static-1.13745",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13617",
  "reporting-filters": "/reporting-filters/static-1.862",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2402"
}
};
